import { ElNotification } from 'element-plus'

interface NotificationOptions {
  title?: string
  message: string
  type: 'success' | 'warning' | 'info' | 'error'
  duration?: number
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left'
}

const handleNotification = (options: NotificationOptions) => {
  ElNotification({
    title: options.title || '通知',
    message: options.message,
    type: options.type,
    duration: options.duration || 3000,
    position: options.position || 'bottom-right'
  })
}

/**
 * 顯示成功通知
 * @param {string} message - 通知的內容。
 * @param {string} [title] - 通知的標題。
 */
export const notifySuccess = (message: string, title?: string) => {
  handleNotification({ message, title: title || '成功', type: 'success' })
}

/**
 * 顯示警告通知
 * @param {string} message - 通知的內容。
 * @param {string} [title] - 通知的標題。
 */
export const notifyWarning = (message: string, title?: string) => {
  handleNotification({ message, title: title || '警告', type: 'warning' })
}

/**
 * 顯示提示通知
 * @param {string} message - 通知的內容。
 * @param {string} [title] - 通知的標題。
 */
export const notifyInfo = (message: string, title?: string) => {
  handleNotification({ message, title: title || '提示', type: 'info' })
}

/**
 * 顯示錯誤通知
 * @param {string} message - 通知的內容。
 * @param {string} [title] - 通知的標題。
 */
export const notifyError = (message: string, title?: string) => {
  handleNotification({ message, title: title || '錯誤', type: 'error' })
}
